<template>
  <footer class="footer" ref="footer">
    <ul class="footer-items">
      <li v-for="(item, i) in links" class="footer-item" :key="i">
        <router-link
          class="footer-item_link"
          :to="{ path: item.link }"
          :title="item.title"
        >
          {{ item.name }}
        </router-link>
      </li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: 'FootBar',

  props: {
    menuLinks: Array
  },

  data () {
    return {
      height: 0
    }
  },

  methods: {
    getFooterHeight (event) {
      const footerHeight = this.$refs.footer.clientHeight
      if (this.height !== footerHeight) {
        this.height = footerHeight
        this.$emit('footer-resize', this.height)
      }
    }
  },

  computed: {
    authenticated () {
      return this.$store.getters['authent/isAuthenticated']
    },

    links () {
      // return !this.authenticated ? this.menuLinks.slice(2) : this.menuLinks
      return this.menuLinks
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getFooterHeight)
      // Init footer height
      this.getFooterHeight()
    }),

    window.scrollTo(0,0);
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.getFooterHeight)
  }
}
</script>
